define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		getActionView: function(/*csi.def.ViewRef?*/vr) {
			// summary: Switchboard/ViewRef is not used for purpose of popup when switching items
			return null;
		},

		postProcessSuccess: function() {
			// summary: refresh view - toolbar plugin will take care of updating view with new selection
			if (!this.inherited(arguments) && !this.widget.getDeferred()) {
				this.widget.refreshWidget();
			}
		}
	});
});